var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('survalent-operations-table',{attrs:{"operations_records":_vm.operations_records}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }